import { useTranslation } from "react-i18next";
import { Page } from "../../components/Page";
import "../../../i18n/i18n";

export const VehicleRestitutionSummaryStep = () => {
  const { t } = useTranslation();

  return <Page title={t("restitution.summary.title")} />;
};
